import type { DilutionRiskRank } from "@/domains/vote-page/voting-gauge"
import { formatPercentage } from "@/domains/library"

interface DilutionRiskColumnProps {
  dilutionRisk: number
  dilutionRiskRank: DilutionRiskRank
  dilutionRiskColor: string
}

export const DilutionRiskColumn = ({ dilutionRisk, dilutionRiskRank, dilutionRiskColor }: DilutionRiskColumnProps) => {
  return (
    <div className="flex flex-col items-end justify-center gap-1">
      <div className="flex items-center gap-1">
        <span className="text-sm text-t100">{formatPercentage(dilutionRisk, 0)}</span>
        <span className="text-xs text-t300">% MAX</span>
      </div>
      <div
        className="h-1.5 w-16 rounded-full"
        style={{
          backgroundColor: dilutionRiskColor,
        }}
      />
    </div>
  )
}
